export default __webpack_public_path__ + "static/media/element_103.c658b0f0.webp";